import React from 'react';
import { Box, Button, Layer, Text, Anchor } from 'grommet';
import { FormClose, StatusGood } from 'grommet-icons';
import { HitScopeToastProps } from '../hitScope.types';

const HitScopeToast: React.FC<HitScopeToastProps> = ({
  toast,
  setToast,
  handleDownloadClip,
}) => {
  return (
    <Layer
      position="bottom"
      modal={false}
      margin={{ vertical: 'medium' }}
      onEsc={() => {
        setToast(null);
      }}
      responsive={false}
      plain
    >
      <Box
        align="center"
        direction="row"
        gap="small"
        justify="between"
        round="medium"
        elevation="medium"
        pad="medium"
        background="status-ok"
      >
        <Box gap="small">
          <Box align="center" direction="row" gap="small">
            <StatusGood />
            {toast && <Text>{toast?.label}</Text>}
          </Box>
          {toast && toast.url && (
            <Anchor onClick={() => toast && handleDownloadClip(toast?.url)}>
              Download here
            </Anchor>
          )}
        </Box>

        <Button
          icon={<FormClose />}
          onClick={() => {
            setToast(null);
          }}
          plain
        />
      </Box>
    </Layer>
  );
};

export default HitScopeToast;
